import { ref } from '@vue/composition-api'
import { FORM_ERROR } from '@/utils/defaultMessages'

export default function useForm() {
  const formRef = ref(null)
  const loading = ref(false)

  function resetForm() {
    if (!formRef.value) return
    formRef.value.reset()
  }

  function resetFormValidation() {
    if (!formRef.value) return
    formRef.value.resetValidation()
  }

  function validateForm() {
    if (!formRef.value) return false

    return formRef.value.validate()
  }

  return {
    formRef,
    loading,
    resetForm,
    resetFormValidation,
    validateForm,
    FORM_ERROR,
  }
}
